// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-viewer-dialog {
  display: flex;
  flex-direction: column;
  width: min(960px, 96vw);
  height: min(90vh, 900px);
  max-height: 90vh;
  background: #111827;
  color: #f8fafc;
}

.pdf-viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.pdf-viewer-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.pdf-viewer-title h2 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pdf-viewer-title mat-icon {
  flex-shrink: 0;
}

.pdf-viewer-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pdf-viewer-body {
  flex: 1;
  min-height: 0;
  background: #0b1220;
}

.pdf-frame {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.pdf-viewer-error {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/pdf-viewer/pdf-viewer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kDAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AADF","sourcesContent":[".pdf-viewer-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(960px, 96vw);\n  height: min(90vh, 900px);\n  max-height: 90vh;\n  background: #111827;\n  color: #f8fafc;\n}\n\n.pdf-viewer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  flex-shrink: 0;\n}\n\n.pdf-viewer-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  mat-icon {\n    flex-shrink: 0;\n  }\n}\n\n.pdf-viewer-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pdf-viewer-body {\n  flex: 1;\n  min-height: 0;\n  background: #0b1220;\n}\n\n.pdf-frame {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: #fff;\n}\n\n.pdf-viewer-error {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 24px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
